import React, { useEffect, useState } from "react";
import { Field, Formik, Form } from "formik";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box, FormGroup, makeStyles, Typography } from "@material-ui/core";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";
import AppCheckbox from "components/Input/AppCheckbox";
import InputUpload from "components/Input/InputUpload";
import * as Yup from "yup";
import { showToast } from "../../../../store/slices/toast";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyConfig } from "store/slices/company";

const styles = makeStyles(() => ({
  title: {
    display: 'flex',
    margin: '2rem 0 1rem 0'
  },
  control: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  textDownload: {
    cursor: 'pointer',
    marginBottom: '1rem',
    '& span': {
      color: AppColor.blue,
      textDecoration: 'underline',
      marginRight: '0.5rem'
    }

  }
}));

const AgreementForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    workerDetail,
    changeProgressStatus,
    display,
    disabled
  } = props;

  const { t } = useTranslation();
  const classes = styles();
  const dispatch = useDispatch();
  const companyConfig = useSelector(getCompanyConfig) || {};
  const [initForm, setInitForm] = useState({
    haveAgreement: false,
    agreementForTaxFile: null,
    agreementFile: null
  });

  const {
    id,
    agreementForTaxDoc: agreementForTaxFile,
    agreementForTaxDocAws3Link: agreementForTaxDocAws3Link,
    agreementFile: agreementFile,
    agreementFileAws3Link: agreementFileAws3Link
  } = workerDetail;

  const validationSchema = Yup.object().shape({
    agreementForTaxFile: Yup.mixed().required("validation.requiredFile"),
    agreementFile: Yup.mixed().required("validation.requiredFile")
  });

  const handleSubmitForm = (form) => {

    if (!workerDetail.accountName) {
      dispatch(
        showToast({
          type: "danger",
          message: t(`toast.error.agreement_bank_account`),
        })
      );
      return;
    }

    const params = {
      ...form,
      id
    };

    onSubmit(params);
  };

  useEffect(() => {
    if (workerDetail && agreementForTaxFile) {
      const initial = {
        agreementFile: agreementFile === '' ? null : agreementFile,
        agreementFileAws3Link: agreementFileAws3Link === '' ? null : agreementFileAws3Link,
        agreementForTaxDocAws3Link: agreementForTaxDocAws3Link === '' ? null : agreementForTaxDocAws3Link,
        agreementForTaxFile: agreementForTaxFile === '' ? null : agreementForTaxFile,
        haveAgreement: !!agreementForTaxFile
      };
      validationSchema
        .isValid(initial)
        .then((valid) => {
          setTimeout(() => {
            changeProgressStatus(4, valid);
          }, 500);
        });
      setInitForm(initial);
    }
  }, [workerDetail]);

  const handleDownloadAgreementFileError = () => {
    dispatch(
      showToast({
        type: "danger",
        message: t('text.messageAgreementFileError')
      })
    );
  }

  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={initForm}
      validationSchema={validationSchema}
    >
      {({ values }) => {
        return (
          <Form className={`${classes.container} ${!display && 'hidden'}`}>
            <Box className={classes.title}>
              <Typography variant="h5">
                {t("title.agreement")}
              </Typography>
            </Box>
            <Field
              component={AppCheckbox}
              label={t("text.acceptAgreement")}
              id="haveAgreement"
              name="haveAgreement"
              disabled={disabled}
            />
            {
              companyConfig.workerDownloadAgreementFile && companyConfig.workerDownloadAgreementFile !== ''
              ?<a href={companyConfig.workerDownloadAgreementFileAws3Link} download="CareAid_Employment_Contract.docx">
                <Box className={classes.textDownload}>
                  <span>{t('label.downloadAgreement')}</span>
                  <i className="fas fa-download"></i>
                </Box>
              </a>
              :<a onClick={handleDownloadAgreementFileError}>
                <Box className={classes.textDownload}>
                  <span>{t('label.downloadAgreement')}</span>
                  <i className="fas fa-download"></i>
                </Box>
              </a>
            }
            {/* {typeof values.agreementFile === 'string' && values.agreementFile && (
              <Box display="flex" justifyContent="flex-end">
                <a
                  href={values.agreementFileAws3Link}
                  download={values.agreementFile}
                >
                  <Box className={classes.textDownload} style={{ marginBottom: 0 }}>
                    <span>{t('label.download')}</span>
                    <i className="fas fa-download"></i>
                  </Box>
                </a>
              </Box>
            )} */}
            <Field
              component={InputUpload}
              accept="application/pdf"
              name="agreementFile"
              disabled={disabled}
              showIconUpload={true}
              showIconDownload={typeof values.agreementFile === 'string' && values.agreementFile}
              renderIconDownload={() => (
                <a
                  href={values.agreementFileAws3Link}
                  download={values.agreementFile}
                >
                  <Box className={classes.textDownload} style={{ marginBottom: 0 }}>
                    <span>{t('label.download')}</span>
                    <i className="fas fa-download"></i>
                  </Box>
                </a>
              )}
            />
            <Box className={classes.title}>
              <Typography variant="h5">
                {t("title.agreementForTax")}
                <span style={{ color: AppColor.red }}>*</span>
              </Typography>
            </Box>
            <Box>
              <Typography variant="body1">
                {t("text.downloadAndSignDocument")}
              </Typography>
            </Box>
            
            {
              companyConfig.workerDownloadAgreementTaxFile && companyConfig.workerDownloadAgreementTaxFile !== ''
              ?<a href={companyConfig.workerDownloadAgreementTaxFileAws3Link} download="TFN_declaration_form_N3092.pdf">
                <Box className={classes.textDownload}>
                  <span>{t('label.downloadAgreementForTax')}</span>
                  <i className="fas fa-download"></i>
                </Box>
              </a>
              :<a onClick={handleDownloadAgreementFileError}>
                <Box className={classes.textDownload}>
                  <span>{t('label.downloadAgreementForTax')}</span>
                  <i className="fas fa-download"></i>
                </Box>
              </a>
            }
            {/* {typeof values.agreementForTaxFile === 'string' && values.agreementForTaxFile && (
              <Box display="flex" justifyContent="flex-end">
                <a
                  href={values.agreementForTaxDocAws3Link}
                  download={values.agreementForTaxFile}
                >
                  <Box className={classes.textDownload} style={{ marginBottom: 0 }}>
                    <span>{t('label.download')}</span>
                    <i className="fas fa-download"></i>
                  </Box>
                </a>
              </Box>
            )} */}
            <Field
              component={InputUpload}
              accept="application/pdf"
              name="agreementForTaxFile"
              disabled={disabled}
              showIconUpload={true}
              showIconDownload={typeof values.agreementForTaxFile === 'string' && values.agreementForTaxFile}
              renderIconDownload={() => (
                <a
                  href={values.agreementForTaxDocAws3Link}
                  download={values.agreementForTaxFile}
                >
                  <Box className={classes.textDownload} style={{ marginBottom: 0 }}>
                    <span>{t('label.download')}</span>
                    <i className="fas fa-download"></i>
                  </Box>
                </a>
              )}
            />
            {
              !disabled && (
                <FormGroup className={classes.control}>
                  <AppButton
                    label={`${t("button.submit")}`}
                    rounder
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={!values.haveAgreement || isSubmitting}
                  />
                </FormGroup>
              )
            }
          </Form>
        );
      }}
    </Formik>
  );
};

AgreementForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  display: PropTypes.bool,
  disabled: PropTypes.bool,
  workerDetail: PropTypes.any,
  changeProgressStatus: PropTypes.func
};

export default AgreementForm;
